import {CurrentProjectIdProvider} from '@adsk/alloy-provider/es/CurrentProjectIdContext';
import {DeletedUsersProvider as AlloyDeletedUsersProvider} from '@adsk/alloy-provider/es/DeletedUsers';
import DeletedUserFetcher from './DeletedUsersFetcher';
import PropTypes from 'prop-types';
import React from 'react';
import {childrenType} from '../../constants/proptype-validation';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const DeletedUsersProvider = ({projectId, children}) => (
  <CurrentProjectIdProvider projectId={projectId}>
    <AlloyDeletedUsersProvider>
      {children}
      {featureFlags.get(FEATURE_FLAGS.FETCH_DELETED_USERS) && <DeletedUserFetcher projectId={projectId} />}
    </AlloyDeletedUsersProvider>
  </CurrentProjectIdProvider>
);

DeletedUsersProvider.propTypes = {
  children: childrenType.isRequired,
  projectId: PropTypes.string.isRequired
};
DeletedUsersProvider.displayName = 'DeletedUsersProvider';
export default DeletedUsersProvider;
